// Signature-stable delegate (W3c). The core moved to `@heidi/session/data` with
// the session-header modal cores; this file keeps the module identity
// and owns the two toasts the headless zone may not perform.
//
// The cohort trio this hook used to read directly — `useRBACPermissionCheck` +
// `useCombinedQueriesTeamGeneralInfo` + `selectedReviewMemberAtom` — crosses
// through ruling 32's required `useSessionAccessContext` config member, so none
// of the three is named here any more.
//
// This stays a BODIED delegate rather than dissolving to a `meta` re-export
// (tier T1 of the toast ladder): the copy interpolates `error.message`, which is a
// computed value, so it is T2 by the ladder's own test.
import { toast } from '@heidi/design-system/toast';
import { useMutateUpdateOtherUserSession as useMutateUpdateOtherUserSessionCore } from '@heidi/session/data';

export function useMutateUpdateOtherUserSession(
  isSessionLinked?: boolean,
  patientProfileId?: string
) {
  return useMutateUpdateOtherUserSessionCore(isSessionLinked, patientProfileId, {
    onSessionUpdated: () =>
      toast({
        tone: 'success',
        title: 'Session updated successfully',
      }),
    onUpdateSessionError: (error) =>
      toast({
        tone: 'destructive',
        title: 'Failed to update session',
        description: error instanceof Error ? error.message : 'Unknown error occurred',
      }),
  });
}
